// import { Suspense, createContext, lazy, useEffect, useState } from "react";
// import { Route, Routes } from "react-router-dom";
// import Loader from "./views/Components/Loader/Loader";
// import AppBooster from "./helpers/components/AppBooster";
// import AuthLayout from "./views/Auth/AuthLayout";
// import Login from "./views/Auth/Login";
// import Forgot from "./views/Auth/Forgot";
// import SetPassword from "./views/Auth/SetPassword";
// import OtpVerification from "./views/Auth/OtpVerification";
// import Register from "./views/Auth/Register";
// import InnerLayout from "./views/Inner/InnerLayout";
// import Dashboard from "./views/Inner/Dashboard";
// import MyProfile from "./views/Inner/MyProfile";
// import InnerLayout2 from "./views/Inner/InnerLayout2";
// import SupportTicket from "./views/Support/SupportTicket";
// import EdisonSupport from "./views/Support/EdisonSupport";
// import ChangePassword from "./views/Inner/Changepassword";
// import Notifications from "./views/Notifications/Notifications";
// import InnerLayout3 from "./views/Inner/InnerLayout3";
// import Referral from "./views/Inner/Referral/Referral";
// import TotalReferral from "./views/Inner/Referral/TotalReferral";
// import TotalIncome from "./views/Inner/Referral/TotalIncome";
// import WithdrawHistory from "./views/Inner/Withdraw/WithdrawHistory";
// import Withdraw from "./views/Inner/Withdraw/Withdraw";
// import TwoFactorAuthentication from "./views/Inner/Tfa/TwoFactorAuthentication";
// import AuthenticationApp from "./views/Inner/Tfa/AuthenticationApp";
// import BankDetails from "./views/Inner/BankDetails/BankDetails";
// import BonusDetails from "./views/Inner/Referral/BonusDetails";
// import ReferralPlan from "./views/Inner/Referral/ReferralPlan";
// import Referral2 from "./views/Inner/Referral/Referral2";
// import Profile from "./views/Inner/Profile/Profile";
// import ProfileDetails from "./views/Inner/Profile/ProfileDetails";
// import Following from "./views/Inner/Profile/Following";
// import Followers from "./views/Inner/Profile/Followers";
// import BecomeAPartner from "./views/Inner/Partner/BecomeAPartner";
// import MyFollowers from "./views/myprofile/MyFollwers";
// import Myfollowings from "./views/myprofile/Myfollowings";
// import BlockUsers from "./views/myprofile/BlockUsers";

// import "./dev/dev.scss";
// import PostDetails from "./views/Inner/Profile/PostDetails";
// import ComingSoon from "./views/Cms/ComingSoon";
// import EdisonSupportLogout from "./views/Support/EdisonSupportLogout";
// import Terms from "./views/Cms/Terms";
// import Privacy from "./views/Cms/Privacy";
// import InnerLayout4 from "./views/Inner/InnerLayout4";
// import LoginDelete from "./views/Auth/LoginDelete";
// import Post from "./views/Inner/Profile/Post";
// import Angelo from "./views/Members/Angelo";
// import MemberLayout from "./views/Members/MemberLayout";
// import Giulia from "./views/Members/Giulia";
// import Gloria from "./views/Members/Gloria";
// import Leonardo from "./views/Members/Leonardo";
// import Osiel from "./views/Members/Osiel";
// import Radames from "./views/Members/Radames";
// import Valentino from "./views/Members/Valentino";
// import AppDownloadPrompt from "./views/Components/prompt/AppDownloadPrompt";
// import Luca from "./views/Members/Luca";
// import { ScrollProvider } from "./views/Components/ScrollContext";
// import SinglePostDetails from "./views/Inner/Profile/SinglePostDetails";
// import SingleTempNews from "./views/Landing/news_update/SingleTempNews";
// import OwnPost from "./views/Inner/Profile/OwnPost";
// import useAutoRefresh from "./hooks/useAutoRefresh";
// import UpdateAvailablePrompt from "./views/Components/prompt/UpdateAvailablePrompt";

// import "./assets/scss/Common.scss";
// import "./assets/scss/InnerHeader.scss";
// import "./assets/scss/Loader.scss";

// import "./assets/scss/Landing.scss";
// import "./assets/scss/LandingSwiper.scss";
// import "./assets/scss/IphoneLanding.scss";
// import "./assets/scss/MacLanding.scss";
// import "./assets/scss/LandingCms.scss";


// import "./assets/scss/Auth.scss";
// import "./assets/scss/Inner.scss";
// import "./assets/scss/Cms.scss";
// import "./assets/scss/MobileApp.scss";

// import "./dev/dev.scss";

// const Landing = lazy(() => import("./views/Landing/Landing"));

// const LandingLayout = lazy(() => import("./views/Landing/LandingLayout"));

// // For windows
// const LandingSwiper = lazy(() => import("./views/Landing/LandingSwiper"));

// // For Mac
// const LandingSwiperMac = lazy(() => import("./views/LandingMac/LandingSwiper"));

// // For Iphone
// const LandingIphone = lazy(() => import("./views/LandingIphone/LandingSwiper"));
// export const EdisonContext = createContext(0);

// function App() {
//   /* new build update without manual refreshing */
//   const { updateAvailable, reloadNow } = useAutoRefresh(60000);

//   const [device, setDevice] = useState("Win");

//   useEffect(() => {
//     const ua = navigator.userAgent.toLowerCase();
//     const isSafari =
//       ua.includes("safari") &&
//       !ua.includes("chrome") &&
//       !ua.includes("chromium");

//     if (isSafari) {
//       if (ua.includes("iphone")) {
//         setDevice("iphone");
//       } else if (ua.includes("macintosh") && navigator.maxTouchPoints > 1) {
//         setDevice("Mac");
//       } else if (ua.includes("macintosh")) {
//         setDevice("Mac");
//       } else {
//         setDevice("Mac");
//       }
//     } else {
//       setDevice("Win");
//     }
//   }, []);

//   const [goToEdison, setGoToEdison] = useState(false);

//   return (
//     <Suspense fallback={<Loader />}>
//       <ScrollProvider>
//         <EdisonContext.Provider value={{ goToEdison, setGoToEdison }}>
//           <UpdateAvailablePrompt show={updateAvailable} onReload={reloadNow} />
//           <AppDownloadPrompt />
//           <AppBooster>
//             <Routes>
//               <Route element={<LandingLayout />}>
//                 <Route path="/devl" element={<Landing />} />

//                 <Route
//                   path="/"
//                   element={
//                     <>
//                       {device === "Win" && <LandingSwiper />}

//                       {device === "Mac" && <LandingSwiperMac />}

//                       {device === "iphone" && <LandingIphone />}
//                     </>
//                   }
//                 />
//               </Route>
//               <Route element={<AuthLayout />}>
//                 <Route path="/login" element={<Login />} />
//                 <Route path="/delete_account" element={<LoginDelete />} />

//                 <Route path="/register" element={<Register />} />
//                 <Route path="/forgot" element={<Forgot />} />
//                 <Route path="/set-password" element={<SetPassword />} />
//                 <Route path="/otp" element={<OtpVerification />} />
//                 <Route path="/verifytfa" element={<AuthenticationApp />} />
//               </Route>

//               <Route element={<InnerLayout />}>
//                 <Route path="/dashboard" element={<Dashboard />} />

//                 <Route path="/profile" element={<Profile />} />
//                 <Route
//                   path="/profile-details/:id"
//                   element={<ProfileDetails />}
//                 />
//                 <Route path="/myprofile" element={<MyProfile />} />
//                 <Route path="/change-password" element={<ChangePassword />} />
//                 <Route path="/following/:id" element={<Following />} />
//                 <Route path="/followers/:user_id" element={<Followers />} />
//                 <Route path="/user_post/:id" element={<Post />} />

//                 <Route path="/myfollowers" element={<MyFollowers />} />
//                 <Route path="/myfollowing" element={<Myfollowings />} />
//                 <Route path="/blocklist" element={<BlockUsers />} />
//                 <Route
//                   path="/tempedison-support"
//                   element={<EdisonSupportLogout />}
//                 />

//                 <Route
//                   path="/two-factor-authentication"
//                   element={<TwoFactorAuthentication />}
//                 />
//                 <Route
//                   path="/authentication-app"
//                   element={<AuthenticationApp />}
//                 />
//                 <Route path="/community" element={<PostDetails />} />
//                 <Route
//                   path="/single_community"
//                   element={<SinglePostDetails />}
//                 />
//                 <Route path="/share_temp_news" element={<SingleTempNews />} />
//                 <Route path="/mypost" element={<OwnPost />} />
//               </Route>

//               <Route element={<InnerLayout2 />}>
//                 <Route path="/support-ticket" element={<SupportTicket />} />
//                 <Route path="/notifications" element={<Notifications />} />
//               </Route>

//               <Route element={<InnerLayout3 />}>
//                 <Route path="/referral" element={<Referral />} />
//                 <Route path="/referral2" element={<Referral2 />} />
//                 <Route path="/become-partner" element={<BecomeAPartner />} />

//                 <Route path="/total-referral" element={<TotalReferral />} />
//                 <Route path="/total-income" element={<TotalIncome />} />

//                 <Route path="/withdraw" element={<Withdraw />} />
//                 <Route path="/withdraw-history" element={<WithdrawHistory />} />

//                 <Route path="/bonus-details" element={<BonusDetails />} />

//                 <Route path="/bank-details" element={<BankDetails />} />

//                 <Route path="/referral-plan" element={<ReferralPlan />} />
//                 <Route path="/terms-and-conditions" element={<Terms />} />
//                 <Route path="/privacy-policy" element={<Privacy />} />
//               </Route>

//               <Route element={<InnerLayout4 />}>
//                 <Route
//                   path="/edison-support/:ticketId?"
//                   element={<EdisonSupport />}
//                 />
//               </Route>
//               <Route element={<MemberLayout />}>
//                 <Route path="/luca" element={<Luca />} />
//                 <Route path="/angelo" element={<Angelo />} />
//                 <Route path="/giulia" element={<Giulia />} />
//                 <Route path="/gloria" element={<Gloria />} />
//                 <Route path="/leonardo" element={<Leonardo />} />
//                 <Route path="/osiel" element={<Osiel />} />
//                 <Route path="/radames" element={<Radames />} />
//                 <Route path="/valentino" element={<Valentino />} />
//               </Route>

//               <Route path="/coming-soon" element={<ComingSoon />} />
//             </Routes>
//           </AppBooster>
//         </EdisonContext.Provider>
//       </ScrollProvider>
//     </Suspense>
//   );
// }

// export default App;




import { Suspense, createContext, lazy, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./views/Components/Loader/Loader";
import AppBooster from "./helpers/components/AppBooster";
import { ScrollProvider } from "./views/Components/ScrollContext";
import AppDownloadPrompt from "./views/Components/prompt/AppDownloadPrompt";
import UpdateAvailablePrompt from "./views/Components/prompt/UpdateAvailablePrompt.jsx";
import ReportContent from "./views/Landing/community_compoents/ReportContent.jsx";
import useAutoRefresh from "./hooks/useAutoRefresh.jsx";
import PrivateRoute from "./helpers/private/PrivateRoute.jsx";

import "./assets/scss/Common.scss";
import "./assets/scss/InnerHeader.scss";
import "./assets/scss/Loader.scss";

import "./assets/scss/Landing.scss";
import "./assets/scss/LandingSwiper.scss";
import "./assets/scss/IphoneLanding.scss";
import "./assets/scss/MacLanding.scss";
import "./assets/scss/LandingCms.scss";


import "./assets/scss/Auth.scss";
import "./assets/scss/Inner.scss";
import "./assets/scss/Cms.scss";
import "./assets/scss/MobileApp.scss";
import "./assets/scss/Combine.scss";
import "./assets/scss/Plans.scss";
import "./assets/scss/Pricing.scss";

import "./assets/scss/Scroll.scss";

import "./dev/dev.scss";
import Indistat from "./views/Inner/Indistat/Indistat.jsx";
import NotFound from "./helpers/components/NotFound.jsx";


// Auth
const AuthLayout = lazy(() => import("./views/Auth/AuthLayout"));
const Login = lazy(() => import("./views/Auth/Login"));
const Forgot = lazy(() => import("./views/Auth/Forgot"));
const SetPassword = lazy(() => import("./views/Auth/SetPassword"));
const OtpVerification = lazy(() => import("./views/Auth/OtpVerification"));
const Register = lazy(() => import("./views/Auth/Register"));
const LoginDelete = lazy(() => import("./views/Auth/LoginDelete"));

// Inner (core account) layout + pages
const InnerLayout = lazy(() => import("./views/Inner/InnerLayout"));
const Dashboard = lazy(() => import("./views/Inner/Dashboard"));
const MyProfile = lazy(() => import("./views/Inner/MyProfile"));
const ChangePassword = lazy(() => import("./views/Inner/Changepassword"));

const Profile = lazy(() => import("./views/Inner/Profile/Profile"));
const ProfileDetails = lazy(() => import("./views/Inner/Profile/ProfileDetails"));
const Following = lazy(() => import("./views/Inner/Profile/Following"));
const Followers = lazy(() => import("./views/Inner/Profile/Followers"));
const Post = lazy(() => import("./views/Inner/Profile/Post"));
const PostDetails = lazy(() => import("./views/Inner/Profile/PostDetails"));
const SinglePostDetails = lazy(() => import("./views/Inner/Profile/SinglePostDetails"));
const OwnPost = lazy(() => import("./views/Inner/Profile/OwnPost"));

const MyFollowers = lazy(() => import("./views/myprofile/MyFollwers"));
const Myfollowings = lazy(() => import("./views/myprofile/Myfollowings"));
const BlockUsers = lazy(() => import("./views/myprofile/BlockUsers"));

const TwoFactorAuthentication = lazy(() => import("./views/Inner/Tfa/TwoFactorAuthentication"));
const AuthenticationApp = lazy(() => import("./views/Inner/Tfa/AuthenticationApp"));

const EdisonSupportLogout = lazy(() => import("./views/Support/EdisonSupportLogout"));
const SingleTempNews = lazy(() => import("./views/Landing/news_update/SingleTempNews"));

// InnerLayout2 (support / notifications)
const InnerLayout2 = lazy(() => import("./views/Inner/InnerLayout2"));
const SupportTicket = lazy(() => import("./views/Support/SupportTicket"));
const Notifications = lazy(() => import("./views/Notifications/Notifications"));

// InnerLayout3 (referral / finance / cms)
const InnerLayout3 = lazy(() => import("./views/Inner/InnerLayout3"));
const Referral2 = lazy(() => import("./views/Inner/Referral/Referral2"));
const BecomeAPartner = lazy(() => import("./views/Inner/Partner/BecomeAPartner"));
const TotalReferral = lazy(() => import("./views/Inner/Referral/TotalReferral"));
const TotalIncome = lazy(() => import("./views/Inner/Referral/TotalIncome"));
const Withdraw = lazy(() => import("./views/Inner/Withdraw/Withdraw"));
const WithdrawHistory = lazy(() => import("./views/Inner/Withdraw/WithdrawHistory"));
const BonusDetails = lazy(() => import("./views/Inner/Referral/BonusDetails"));
const BankDetails = lazy(() => import("./views/Inner/BankDetails/BankDetails"));
// const ReferralTree = lazy(() => import("./views/Inner/Referral/ReferralTree"));
const ReferralPlan = lazy(() => import("./views/Inner/Referral/ReferralPlan"));
const Terms = lazy(() => import("./views/Cms/Terms"));
const Privacy = lazy(() => import("./views/Cms/Privacy"));
const Privacyweb = lazy(() => import("./webPrivacy/PrivacyWeb.jsx"));
// const Courses = lazy(() => import("./views/Inner/Courses/Courses"));
// const CoursesDetails = lazy(() => import("./views/Inner/Courses/CoursesDetails"));
// const StrategyDetails = lazy(() => import("./views/Inner/Strategy/StrategyDetails"));

// InnerLayout4 (edison support)
const InnerLayout4 = lazy(() => import("./views/Inner/InnerLayout4"));
const EdisonSupport = lazy(() => import("./views/Support/EdisonSupport"));

// Members
const MemberLayout = lazy(() => import("./views/Members/MemberLayout"));
const Luca = lazy(() => import("./views/Members/Luca"));
const Angelo = lazy(() => import("./views/Members/Angelo"));
const Giulia = lazy(() => import("./views/Members/Giulia"));
const Gloria = lazy(() => import("./views/Members/Gloria"));
const Leonardo = lazy(() => import("./views/Members/Leonardo"));
const Osiel = lazy(() => import("./views/Members/Osiel"));
const Radames = lazy(() => import("./views/Members/Radames"));
const Valentino = lazy(() => import("./views/Members/Valentino"));

// Home layout + pages
const HomeLayout = lazy(() => import("./views/Home/HomeLayout.jsx"));
const Home = lazy(() => import("./views/Home/Home.jsx"));
const AboutUs = lazy(() => import("./views/Home/AboutUs.jsx"));
const Agents = lazy(() => import("./views/Home/Agents.jsx"));
const Application = lazy(() => import("./views/Home/Application.jsx"));
const Network = lazy(() => import("./views/Home/Network.jsx"));
const RoadMap = lazy(() => import("./views/Home/RoadMap.jsx"));
const NewsUpdate = lazy(() => import("./views/Home/NewsUpdate.jsx"));
const Community = lazy(() => import("./views/Home/Community.jsx"));
const EdisonAgent = lazy(() => import("./views/Home/EdisonAgent.jsx"));
/* events */
const EventLiveLayout = lazy(() => import("./views/Inner/EventLive/EventLiveLayout.jsx"));
const EventLive = lazy(() => import("./views/Inner/EventLive/EventLive.jsx"))
const EventLiveHistory = lazy(() => import("./views/Inner/EventLive/EventLiveHistory.jsx"));

const EventLiveStart = lazy(() => import("./views/Inner/EventLive/EventLiveStart.jsx"));

/* Auth combine */
const AuthCombineLayout = lazy(() => import("./views/AuthCombine/AuthCombineLayout.jsx"));
const AuthCombine = lazy(() => import("./views/AuthCombine/AuthCombine.jsx"));
const RegisterCombine = lazy(() => import("./views/AuthCombine/RegisterCombine.jsx"));
const LoginCombine = lazy(() => import("./views/AuthCombine/LoginCombine.jsx"));
const PlatformIntro = lazy(() => import("./views/AuthCombine/PlatformIntro.jsx"));
/* plans */
const SubscriptionPlans = lazy(() => import("./views/Inner/subscription-plans-react/subscription-plans"));

// Misc
const ComingSoon = lazy(() => import("./views/Cms/ComingSoon"));

export const EdisonContext = createContext(0);



function App() {
  const { updateAvailable, reloadNow } = useAutoRefresh(60000);
  const [goToEdison, setGoToEdison] = useState(false);

  return (
    <ScrollProvider>
      <EdisonContext.Provider value={{ goToEdison, setGoToEdison }}>
        <UpdateAvailablePrompt show={updateAvailable} onReload={reloadNow} />
        <AppDownloadPrompt />
        <AppBooster>
          {/* <ReportContent key={"MCEPv2U_{0Dkt0[h"} /> */}

          <Suspense fallback={<Loader />}>
            <Routes>
              <Route element={<HomeLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about-us" element={<PrivateRoute />}>
                  <Route index element={<AboutUs />} />
                </Route>
                <Route path="/agent" element={<Agents />} />
                <Route path="/application" element={<PrivateRoute />}>
                  <Route index element={<Application />} />
                </Route>

                <Route path="/network" element={<PrivateRoute />}>
                  <Route index element={<Network />} />
                </Route>

                <Route path="/road-map" element={<PrivateRoute />}>
                  <Route index element={<RoadMap />} />
                </Route>

                <Route path="/news-update" element={<PrivateRoute />}>
                  <Route index element={<NewsUpdate />} />
                </Route>

                <Route path="/community_home" element={<PrivateRoute />}>
                  <Route index element={<Community />} />
                </Route>

                <Route path="/edison-agent" element={<PrivateRoute />}>
                  <Route index element={<EdisonAgent />} />
                </Route>
              </Route>

              <Route element={<AuthLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/delete_account" element={<LoginDelete />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot" element={<Forgot />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/otp" element={<OtpVerification />} />
                <Route path="/verifytfa" element={<AuthenticationApp />} />
              </Route>

              <Route element={<InnerLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile-details/:id" element={<ProfileDetails />} />
                <Route path="/myprofile" element={<MyProfile />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/following/:id" element={<Following />} />
                <Route path="/followers/:user_id" element={<Followers />} />
                <Route path="/user_post/:id" element={<Post />} />

                <Route path="/myfollowers" element={<MyFollowers />} />
                <Route path="/myfollowing" element={<Myfollowings />} />
                <Route path="/blocklist" element={<BlockUsers />} />


                <Route path="/two-factor-authentication" element={<TwoFactorAuthentication />} />
                <Route path="/authentication-app" element={<AuthenticationApp />} />
                <Route path="/community" element={<PostDetails />} />
                <Route path="/single_community" element={<SinglePostDetails />} />
                <Route path="/share_temp_news" element={<SingleTempNews />} />

                <Route path="/mypost" element={<OwnPost />} />
              </Route>

              <Route element={<InnerLayout2 />}>
                <Route path="/support-ticket/:type?" element={<SupportTicket />} />
                <Route path="/notifications" element={<Notifications />} />
              </Route>

              <Route element={<InnerLayout3 />}>
                <Route path="/referral" element={<Referral2 />} />
                <Route path="/becomepartner" element={<BecomeAPartner />} />

                <Route path="/totalreferral" element={<TotalReferral />} />
                <Route path="/total-income" element={<TotalIncome />} />

                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/withdraw-history" element={<WithdrawHistory />} />

                <Route path="/bonusdetails" element={<BonusDetails />} />

                <Route path="/bank-details" element={<BankDetails />} />
                {/* <Route path="/referral-tree" element={<ReferralTree />} /> */}
                <Route path="/referral-plan" element={<ReferralPlan />} />
                <Route path="/terms-and-conditions" element={<Terms />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                {/* <Route path="/courses" element={<Courses />} /> */}
                {/* <Route path="/courses-details" element={<CoursesDetails />} /> */}

                {/* <Route path="/strategy-details" element={<StrategyDetails />} /> */}
                <Route path='/indistat' element={<Indistat />} />
                <Route path="/privacy-policy-web" element={<Privacyweb />} />
              </Route>

              <Route element={<InnerLayout4 />}>
                <Route path="/edison-support/:ticketId?/:type?" element={<EdisonSupport />} />
                <Route path="/tempedison-support" element={<EdisonSupportLogout />} />
              </Route>

              <Route element={<MemberLayout />}>
                <Route path="/luca" element={<Luca />} />
                <Route path="/angelo" element={<Angelo />} />
                <Route path="/giulia" element={<Giulia />} />
                <Route path="/gloria" element={<Gloria />} />
                <Route path="/leonardo" element={<Leonardo />} />
                <Route path="/osiel" element={<Osiel />} />
                <Route path="/radames" element={<Radames />} />
                <Route path="/valentino" element={<Valentino />} />
              </Route>

              <Route path="/coming-soon" element={<ComingSoon />} />

              <Route path="/event-start" element={<EventLiveStart />} />

              <Route element={<EventLiveLayout />}>
                <Route path='/event-live' element={<EventLive />} />
                <Route path='/event-live-history' element={<EventLiveHistory />} />
              </Route>

              {/* <Route element={<AuthCombineLayout />}>
                <Route path='/auth-combine' element={<AuthCombine />} ></Route>
                <Route path='/register-combine' element={<RegisterCombine />} ></Route>
                <Route path='/login-combine' element={<LoginCombine />} ></Route>
              </Route> */}




              {/* <Route path="/platform-intro" element={<PlatformIntro />} />

              <Route path="/plans" element={<SubscriptionPlans />} /> */}

              <Route path="*" element={<NotFound />} />

            </Routes>
          </Suspense>
        </AppBooster>
      </EdisonContext.Provider>
    </ScrollProvider>
  );
}

export default App;